import { render } from "./RadioQuestion.vue?vue&type=template&id=cc575872&scoped=true"
import script from "./RadioQuestion.vue?vue&type=script&lang=js"
export * from "./RadioQuestion.vue?vue&type=script&lang=js"

import "./RadioQuestion.vue?vue&type=style&index=0&id=cc575872&lang=scss&scoped=true"

import exportComponent from "/Users/malik/Sites/ismatgroup-satisfaction/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc575872"]])

export default __exports__